import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe, KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, NgModel } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, debounceTime, filter, startWith } from 'rxjs';
import { ReferralAddress, ReferralEmployer, Referral, GoogleAddress, ReferralMember, ReferralPolicy, Prefrence, ResponseDTO, verifyMemberRequest, verifyMemberResponse } from '../interfaces';
import { DataService } from '../services/data.service';
import { LoggerService } from '../services/logger.service';
import { AlertComponent } from '../dialog/alert.component';
import { ValidationService } from '../services/validation.service';
import { CustommatdateService } from '../services/custommatdate.service';
import { SmartyStreetsService } from 'src/app/shared/smarty-streets.service';
import { AddressService } from 'src/app/shared/address.service';
import { CaptchaService } from 'src/app/shared/captcha.service';
import { config } from 'src/app/shared/config';
const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'MMDDYYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'MM/DD/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};


@Component({
  selector: 'app-ncform',
  templateUrl: './ncform.component.html',
  styleUrls: ['./ncform.component.css'],
  providers: [{ provide: DateAdapter, useClass: CustommatdateService },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    {provide: MAT_DATE_LOCALE, useValue: 'en-US'},
    {provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}}],

})
export class NcformComponent implements OnInit , OnChanges{

  public datePipe: DatePipe;
  timerReset: number = 0;
  apiError: HttpErrorResponse | undefined;
  captchaText: string = '';
  addressSuggestions: any = {
    resAddress: [],
    mailAddress: [],
    referralPolicyAddress: [],
    referralEmployerAddress: []
  }
  disableSearch: any;
  otherMaNumRequired: boolean = false;
  @ViewChild('routingNumber') routingNumberNgModel!: NgModel;
  isRoutingNumberValid:boolean = true;

  ngAfterContentChecked(): void {
    this.changeDetector?.detectChanges();
  }

  verifyMember: verifyMemberRequest = {
    firstNm: '',
    lastNm: '',
    ssnNum: '',
    dobDt: '',
    pierId: null,
  }
  memberObj1: ReferralMember = {
    firstNm: '',
    miNm: '',
    lastNm: '',
    maNum: '',
    dobDt: '',
    ssnNum: '',
    genderCd: '',
    relationshipCd: 'SELF',
    enrolledInPolicy: false,
    existingMember: false,
    medicalCondition: '',
    memberPierId: null,

  }


  resAddress: ReferralAddress = {
    addressType: 'R',
    address1Txt: '',
    address2Txt: '',
    cityTxt: '',
    stateCd: '',
    zipCd: '',
    countyCd: ''
  }
  mailAddress: ReferralAddress = {
    addressType: 'M',
    address1Txt: '',
    address2Txt: '',
    cityTxt: '',
    stateCd: '',
    zipCd: '',
    countyCd: ''
  }

  submittedResponse: ResponseDTO={
    referralId: undefined,
    submittedApplication: ''
  }
  formNc: Referral = {
    referralCase: {
      referralSource: '',
      emailTxt: '',
      phone1Num: '',
      phone2Num: '',
      submitterFirstName: '',
      submitterLastName: '',
      updateReason: '',
      pierId: '',
      existingCase: false,
      useAch: false,
      emailSignup:false,
    },
    referralEmployer: {
      emplyrFein: '',
      emplyrNm: '',
      address1Txt: '',
      address2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      openEnrollmentStartDate: '',
      openEnrollmentEndDate: '',
      phoneNum: '',
      faxNum:'',
      hrContactName:'',
    },
    referralPolicy: {
      policySourceCd: '',
      carrierNm: '',
      addressLine1Txt: '',
      addressLine2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      phoneNum: '',
      planNm: '',
      groupNum: '',
      policyNum: '',
      policyStartDate: null,
      employeePremium: '',
      frequency: '',
      planTier: '',
      planDeductible: '',
      individualMaxDeductible : '',
      familyMaxDeductible : '',
      premiumPaidOption :''
    },
    referralAccount: {
      nameOnBankAccount: '',
      accountType: '',
      bankName: '',
      routingNumber: '',
      accountNumber: '',
    },
    referralAddressList: [],
    referralMemberList: [],
  };
  additionalMaxReached: boolean =false;
  memberPierId!:string |null;
  existingInvalidMemberName: string='';
  previousValRes: any;
  previousValMail: any;
  previousValRefEmp: any;
  previousValRefPol: any;


  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private deviceDetectorService: DeviceDetectorService,
    private dialog: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private sanitize: DomSanitizer,
    private smartyStreetsService: SmartyStreetsService,
    private addressService: AddressService,
    private captchaService: CaptchaService
  ) {
    this.timerStart(15);
    this.datePipe = new DatePipe("en-US");

  }


  resAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('R'),
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'', disabled: true}),
    zipCd: new FormControl(''),
  });

  mailAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('M'),
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'', disabled: true}),
    zipCd: new FormControl(''),
  });

  referralPolicyAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'', disabled: true}),
    zipCd: new FormControl('')
  });


  referralEmployerAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'', disabled: true}),
    zipCd: new FormControl('')
  });

  ngOnChanges(changes: SimpleChanges): void {
    if(this.errorMessageIntialData !=''){
      this.errorMessage = this.getMessageServerDown();
      setTimeout(() => {
        this.changeResetMessage();
        this.errorMessage ='';
      }, 10000);
    }
  }


  @Input() preference: Prefrence | null = null;
  @Input() email: string | undefined ='';
  @Input() tollfreeNo: string | undefined |  null ='';
  @Input() faxNo: string | undefined | null='';
  @Input() address: string='';
  @Input() emailTo: string='';


  @ViewChild('customerForm')
    customerForm: NgForm ={} as NgForm;

  @ViewChild('captcha')
  captcha: NgModel = {} as NgModel;

  @ViewChild('MemberSsn')
  MemberSsn: NgModel = {} as NgModel;

  @ViewChild('otherSsn')
  otherSsn: NgModel = {} as NgModel;

  @ViewChild('otherDob')
  otherDob: NgModel = {} as NgModel;


  existingMemberFn(){
      this.updateReason = ''
      this.signCheckEmailRequired = false;
      this.updateReasonRequired = false;
      this.refferalSourceRequired = false;
      this.firstNameRequired = false;
      this.lastNameRequired = false;
      this.memberSexRequired=false;
      this.ssnMemberRequired = false;
      this.memberDobRequired = false;
      this.memberMedicateRequired = false;
      this.resAddress1Required= false;
      this.resCityRequired= false;
      this.resStateRequired = false;
      this.resZipRequired = false;
      this.isSameRequired = false;
      this.mailAddress1Required = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;
      this.addMember = false;

  }

  goForward() {
    if(this.policyHolderCheck() && !this.employerPolicyCheck()){
      if (this.existingMember == 'No') {
      this.eplyrNmRequired = true;
      this.emplyrAddr1Required = true;
      this.emplyrCityRequired = true;
      this.emplyrStateRequired = true;
      this.emplyrZipCodeRequired = true;
      this.emplyrPhoneRequired = true;
      this.emplyrFeinRequired = true;
      this.emplyrEnrollmentStartRequired = true;
      this.emplyrEnrollmentEndRequired = true;
     }
    this.sourceCdRequired = true;
    if (this.existingMember == 'Yes') {
    this.premiumAmountRequired = true;
    this.deductibleRequired = true;
    this.singleDeductibleRequired = true;
    this.familyDeductibleRequired = true;
    this.frequencyRequired = true;
    this.planTierRequired = true;
    this.premieumPaidOptionRequired = true;
    }
  }
  this.timerReset =Math.random()* 100;
}

checkPage2Valid() {
  if(!this.referralEmployerAddressFormControl.valid) {
    return false;
  }
  if(!this.referralPolicyAddressFormControl.valid) {
    return false;
  }
  return true;
}

  goBack(){
    this.sourceCdRequired = false;
    this.premiumAmountRequired = false;
    this.deductibleRequired = false;
    this.singleDeductibleRequired = false;
    this.familyDeductibleRequired = false;
    this.frequencyRequired = false;
    this.planTierRequired = false;
    this.eplyrNmRequired = false;
    this.emplyrAddr1Required = false;
    this.emplyrAddr2Required = false;
    this.emplyrCityRequired = false;
    this.emplyrStateRequired = false;
    this.emplyrZipCodeRequired = false;
    this.emplyrPhoneRequired = false;
    this.emplyrFeinRequired = false;
    this.policyStateRequired = false;
    this.emplyrEnrollmentStartRequired = false;
    this.emplyrEnrollmentEndRequired = false;
    this.premieumPaidOptionRequired = false;
  }

  isFamilyMemberMedicate: string = '';
  goForward2() {
    if(this.policyHolderCheck() && this.employerPolicyCheck() && !this.familyMemberCheck()){
      this.isFamilyRequired = true;
    }
    if(!this.checkAdditionalMembers()){
      this.additionalMembersReq = true;
    }else{
      this.additionalMembersReq = false;
    }
    if(this.isFamilyMemberMedicate == 'Yes' && this.formNc.referralMemberList.length >50 ){
      this.additionalMaxReached =true;
    }else{
      this.additionalMaxReached=false;
    }
    if(this.otherfirstNm !='' && this.otherlastNm != '' && (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') && this.otherEnrolled !=''){
      this.addClearFamilyFilled = true;
     }else{
      this.addClearFamilyFilled = false;
     }
     this.timerReset =Math.random()* 100;
  }
  goBack2(){
    this.isFamilyRequired = false;
    this.additionalMembersReq = false;
    this.additionalMaxReached=false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.othermaNumRequired = false;
    this.otherEnrolledRequired=false;
    this.otherDueDateRequired=false;
    this.otherDobRequired = false;
    this.addClearFamilyFilled= false;
    this.otherRsRequired=false;
    this.otherGnRequired=false;
    this.otherMaNumRequired = false;
  }
  goForward3() {
    if(this.policyHolderCheck() && this.employerPolicyCheck() && this.familyMemberCheck()
       && !this.rightsResponsibilityCheck()
  ){
      this.signCheckRequired = true;
    } else {
      this.directDeposit();
      this.signDepositeCheck = false;
    }
    this.timerReset =Math.random()* 100;
  }
  goBack3(){
    this.signDepositeCheck = false;
    this.accountHolderNameRequired = false;
    this.depositBankNmRequired =false;
    this.routingNumRequired=false;
    this.accountNumRequired=false;
    this.accountTypeRequired=false;
  }
  goForward4() {
    if(this.signDepositeCheck){
      this.accountHolderNameRequired = true;
      this.depositBankNmRequired =true;
      this.routingNumRequired=true;
      this.accountNumRequired=true;
      this.accountTypeRequired=true;
    }else{
      this.accountHolderNameRequired = false;
      this.depositBankNmRequired = false;
      this.routingNumRequired = false;
      this.accountNumRequired = false;
      this.accountTypeRequired=false;
    }
    this.timerReset =Math.random()* 100;
  }
  goBack4(){
    this.signDepositeCheck = false;
  }
  goForward5() {
    if(this.policyHolderCheck() && this.employerPolicyCheck() && this.familyMemberCheck()
      && this.directDepositCheck()
       && this.rightsResponsibilityCheck()
      ){
      this.signElectronicRequired = true;
      this.signApplicantRequired = true;
      this.signfirstNmRequired = true;
      this.signLastNameRequired = true;
      this.captchaRequired = true;
    }
    if(this.submitCheck()){
      this.submit();
    }
    this.timerReset =Math.random()* 100;
  }
  goBack5(){
    this.signElectronicRequired = false;
    this.signApplicantRequired = false;
    this.signfirstNmRequired = false;
    this.signLastNameRequired = false;
    this.captchaRequired = false;
  }


  forward() {
    if (this.existingMember != '') {
      if(this.signReadEmailCheck) {
        this.signCheckEmailRequired = true;
      }
      else {
        this.signCheckEmailRequired = false;
      }
      if (this.existingMember == 'Yes' && this.updateReason == '') {
        this.updateReasonRequired = true;
      }
      if (this.existingMember == 'No') {
        this.refferalSourceRequired = true;
      }
      if(this.isMemberMedicaid=='Yes'){
        this.maNumRequired = true;
      }
      this.firstNameRequired = true;
      this.lastNameRequired = true;

      this.validateAdress(<ReferralAddress>this.resAddressFormControl.getRawValue(), this.resAddressFormControl,this.addressSuggestions?.resAddress?.length);
      if(this.isSameMailingAddress=='No'){
        this.validateAdress(<ReferralAddress>this.mailAddressFormControl.getRawValue(), this.mailAddressFormControl, this.addressSuggestions?.mailAddress?.length);
      }

      if (this.MemberSsn.value == '') {
        this.ssnMemberRequired = true;
      }
      this.memberDobRequired = true;
      this.memberMedicateRequired = true;
      this.memberSexRequired=true;
      this.resAddress1Required = true;
      this.resCityRequired = true;
      this.resStateRequired = true;
      this.resZipRequired = true;
      this.isSameRequired = true;
      this.mailAddress1Required = true;
      this.mailCityRequired = true;
      this.mailStateRequired = true;
      this.mailZipRequired = true;
    //  this.signCheckEmailRequired = true;
    } else {
      this.updateReasonRequired = false;
      this.refferalSourceRequired = false;
      this.firstNameRequired = false;
      this.lastNameRequired = false;
      this.ssnMemberRequired = false;
      this.memberDobRequired = false;
      this.memberMedicateRequired = false;
      this.resAddress1Required = false;
      this.resCityRequired = false;
      this.resStateRequired = false;
      this.resZipRequired = false;
      this.isSameRequired = false;
      this.mailAddress1Required = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;
      this.signCheckEmailRequired = false;
    }
    this.timerReset =Math.random()* 100;
  }

  voteLink:any;
  downloadLink: any;

  ngOnInit(): void {
    this.captchaText = this.captchaService.generateCaptcha();
    this.voteLink = this.sanitize.bypassSecurityTrustUrl("http://www.geauxvote.com/");
    this.downloadLink = this.sanitize.bypassSecurityTrustUrl("javascript:void(0)");
    this._success.subscribe((message) => (this.successMessage = message));
    this._success.pipe(debounceTime(5000)).subscribe(() => {
      this.successMessage = '';
      //window.location.reload();
    });
    this._danger.subscribe((message) => (this.errorMessage = message));
    this._danger.pipe(debounceTime(3000)).subscribe(() => {
      this.errorMessage = '';
      //window.location.reload();
    });
    this._warning.subscribe((message) => (this.warningMessage = message));
    this._warning.pipe(debounceTime(2000)).subscribe(() => {
      this.warningMessage = '';
    //  window.location.reload();
    });


    let resAddressLine1 = this.resAddressFormControl.controls.address1Txt;
      this.resAddressFormControl.controls.address1Txt.valueChanges.pipe(
            startWith(''),
            filter(() => !this.disableSearch),
            debounceTime(1000)
          ).subscribe(val => {
            if(this.disableSearch || !val ) return;
      if(this.resAddressFormControl.controls.zipCd.value) return;
      if(val?.length<6){
        this.previousValRes="";
      }
      if (this.previousValRes?.trim() == resAddressLine1?.value?.trim()) return;
      if(
        this.resAddressFormControl.controls.address1Txt.value =='PO BOX') {
        this.addressSuggestions.resAddress = [];
        return
      }
      if(val?.length>5){
        this.setPreviousVal(val, 'resAddress');
        this.fetchAddressList(this.resAddressFormControl, this.resAddressFormControl.controls.address1Txt,'NC', true, 'resAddress');
      }
   })

   let mailAddressLine1 = this.mailAddressFormControl.controls.address1Txt;
      this.mailAddressFormControl.controls.address1Txt.valueChanges.pipe(
          startWith(''),
          filter(() => !this.disableSearch),
          debounceTime(1000)
        ).subscribe(val => {
      if(this.disableSearch || !val ) return;
      if(val?.length<6){
        this.previousValMail="";
      }
      if (this.previousValMail?.trim() == mailAddressLine1?.value?.trim()) return;
      if(this.mailAddressFormControl.controls.zipCd.value) return;
      if(val?.length>5){
        this.setPreviousVal(val, 'mailAddress');
        this.fetchAddressList(this.mailAddressFormControl, this.mailAddressFormControl.controls.address1Txt, '', false, 'mailAddress');
      }
    })

    let refEmpAddressLine1 = this.referralEmployerAddressFormControl.controls.address1Txt;
      this.referralEmployerAddressFormControl.controls.address1Txt.valueChanges.pipe(
        startWith(''),
        filter(() => !this.disableSearch),
      ).subscribe(val => {

        if(this.disableSearch || !val ) return;
        if(val?.length<6){
          this.previousValRefEmp="";
        }
        if (this.previousValRefEmp?.trim() == refEmpAddressLine1?.value?.trim()) return;
        if(this.referralEmployerAddressFormControl.controls.zipCd.value) return;
        if(val?.length>5){
          this.setPreviousVal(val, 'referralEmployerAddress');
          this.fetchAddressList(this.referralEmployerAddressFormControl, this.referralEmployerAddressFormControl.controls.address1Txt, '', false, 'referralEmployerAddress')
        }    
       })

      let refPolAddressLine1 = this.referralPolicyAddressFormControl.controls.address1Txt;       
      this.referralPolicyAddressFormControl.controls.address1Txt.valueChanges.pipe(
        startWith(''),
        filter(() => !this.disableSearch),
        debounceTime(1000)
      ).subscribe(val => {
        if(this.disableSearch || !val ) return;
        if(val?.length<6){
          this.previousValRefPol="";
        }        
        if (this.previousValRefPol?.trim() == refPolAddressLine1?.value?.trim()) return;        
        if(this.referralPolicyAddressFormControl.controls.zipCd.value) return;
        if(val?.length>5){
          this.setPreviousVal(val, 'referralPolicyAddress');
          this.fetchAddressList(this.referralPolicyAddressFormControl, this.referralPolicyAddressFormControl.controls.address1Txt, '', false, 'referralPolicyAddress');
        }    
     })



}

generateCaptcha(): void {
  this.captchaText = this.captchaService.generateCaptcha();
}
playCaptchaAudio(): void {
  this.captchaService.playCaptchaAudio();
}

  // Method to check if an address contains a PO Box
  isPOBox(address:string):boolean {
    const poBoxPatterns = [/P\.?O\.?\s?Box/i, /Post\s?Office\s?Box/i];
    // Add more patterns if needed
    return poBoxPatterns.some(pattern =>
    pattern.test(address));
  }


  fetchAddressList(formGroup: FormGroup, control: FormControl, requiredState: string, stateRestrciton: boolean, propName: string) {
    if(control.value.length > 5){
      const resAddress = formGroup.getRawValue();
      let address1Line = this.capitalize(control.value.toLowerCase());
      let existingAddress = this.addressSuggestions[propName].filter((item: any)  => 
        item.street_line?.includes(address1Line));
      if(this.addressSuggestions[propName].length >0 && existingAddress.length>0){
        this.addressSuggestions[propName] = existingAddress;
       
      }else{
      this.addressService.autocompleteAddress(resAddress, requiredState, stateRestrciton).then(
        (data:any)=> {
  
          if(propName=='resAddress'){
            const filteredResults = data.suggestions.filter((result: { street_line: string; }) =>!this.isPOBox(result?.street_line));
            this.addressSuggestions[propName] = filteredResults;
          } else {
            this.addressSuggestions[propName] = data.suggestions;
          }
          if(this.addressSuggestions[propName].length ==0) {
            if( resAddress.cityTxt=='' || resAddress.stateCd=='' ||resAddress.zipCd==''){
              control.setErrors({...(control.errors || {}),'invalid': true});
            }else{
              if(control.errors)
                  delete  control.errors['invalid'];
            }
          }
        }
      );
     }    
    }else{
      this.addressSuggestions[propName] =[];
    }
  
}

capitalize(value: string): string {
  if (!value) return value;
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}


      onFocusInput() {
        //this.addressSuggestions = [];
      }

  model2: string | undefined;
  private _success = new Subject<string>();
  private _warning = new Subject<string>();
  private _danger = new Subject<string>();
  staticAlertClosed = false;
  ssnValidationError: string = '';
  signFirstName: string = '';
  signLastName: string = '';
  signReadEmailCheck: boolean = false;
  signReadCheck: boolean = false;
  signDepositeCheck: boolean = false;

  accountHolderNameRequired: boolean = false;
  depositBankNmRequired: boolean = false;
  routingNumRequired: boolean = false;
  accountNumRequired: boolean = false;
  accountTypeRequired: boolean = false;
  emailTxtRequired: boolean = false;
  accountHolderName: string = '';
  depositBankName: string ='';
  depositRoutingNum: string='';
  depositAccountNum: string='';
  accountType: string ='';
  signElectronicSignatureChecked: boolean = false;
  homeLess: string = '';
  isSameMailingAddress: string = '';
  isHealthInsurance: string = '';
  isMemberMedicaid: string = '';
  maNumRequired: boolean = false;
  existingMember: string  | null = null;
  existingOtherMember: string  | null = null;
  existingMemberVerified: boolean = false;
  updateReason: string = '';
  sourceCdRequired: boolean =false;
  premiumAmountRequired: boolean= false;
  deductibleRequired:boolean=false;
  singleDeductibleRequired:boolean=false;
  familyDeductibleRequired: boolean=false;
  frequencyRequired: boolean=false;
  planTierRequired: boolean=false;
  premieumPaidOptionRequired:boolean=false;
  isFamilyRequired: boolean=false;
  signCheckRequired: boolean=false;
  signCheckEmailRequired: boolean=false;
 // signDepositeRequired: boolean=false;
  signElectronicRequired: boolean=false;
  signApplicantRequired:boolean =false;
  signfirstNmRequired:boolean = false;
  signLastNameRequired:boolean =false;
  captchaRequired:boolean =false;
  editIndex?: number= undefined;
  otherFnRequired: boolean = false;
  otherLnRequired: boolean = false;
  othermaNumRequired: boolean = false;
  otherSsnRequired: boolean = false;
  otherDobRequired: boolean = false;
  otherGnRequired: boolean = false;
  otherRsRequired: boolean = false;
  otherDueDateRequired: boolean = false;
  memberSexRequired:boolean=false;
  otherEnrolledRequired: boolean =false;
  addClearFamilyFilled: boolean =false;
  additionalMembersReq: boolean = false;
  resAddress1Required: boolean= false;
  eplyrNmRequired: boolean = false;
  emplyrAddr1Required: boolean = false;
  emplyrAddr2Required: boolean = false;
  emplyrCityRequired: boolean = false;
  emplyrStateRequired: boolean = false;
  emplyrZipCodeRequired: boolean = false;
  emplyrPhoneRequired: boolean = false;
  emplyrFeinRequired: boolean = false;
  emplyrEnrollmentStartRequired: boolean = false;
  emplyrEnrollmentEndRequired: boolean = false;
  resCityRequired: boolean= false;
  resStateRequired: boolean = false;
  resZipRequired: boolean = false;
  isSameRequired: boolean = false;
  mailAddress1Required: boolean = false;
  mailCityRequired: boolean = false;
  mailStateRequired: boolean = false;
  mailZipRequired: boolean = false;
  updateReasonRequired: boolean =false;
  refferalSourceRequired: boolean = false;
  policyStateRequired: boolean = false;
  firstNameRequired: boolean = false;
  lastNameRequired: boolean = false;
  ssnMemberRequired: boolean = false;
  memberDobRequired: boolean = false;
  memberMedicateRequired: boolean = false;
  showResAddress: boolean = false;
  showMailAddress: boolean = false;
  showEmployerAddress: boolean = false;
  showPolicyAddress: boolean = false;

  successMessage: string = '';
  warningMessage: string = '';
  otherEnrolled: string = '';
  cobra: string = '';
  captchaEntered: string = '';
  isValidFormSubmitted:boolean = false;
  errorMessage: string = '';
  operationText = 'Submit';
  // @Input() contextCd: string = '';
  // @Input() subContextCd: string = '';
  @Input() errorMessageIntialData: string ='';
  isSsnPresentDB: boolean = false;
  memberVOdobDt!: Date ;
  memberVODuedate!: Date | null;
  policyVOpolicyStartDate!: Date;
  cobraStartDate!: Date;
  cobraEndDate!: Date;
  otherdobDate!: Date | null;
  otherMemberDueDate!: Date | null;
  addFamilyMemberButton: boolean =false;
  homeLessPhone1Num: string='';
  homeLessEmailTxt: string='';
  addMember: boolean = false;
  otherMemberPierId: string | null = null;
  openenrollmentstartdate!:Date|null;
  openenrollmentenddate!:Date|null;


  today: Date = today;
  plus1year: Date = new Date(year + 1, month, today.getDate());
  prev10year: Date = new Date(year - 10, month, today.getDate());
  next5year: Date = new Date(year + 5, month, today.getDate());
  prev100year: Date = new Date(year - 100, month, today.getDate());

  originalOrder = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number => {
    return 0;
  };

  otherfirstNm: string = '';
  otherlastNm: string = '';
  othermiNm?: string = '';
  otherssnNum: string = '';
  othermaNum?: string = '';
  medicalCondition:string = '';
  othergencdRf?: string = '';
  otherrshcdRf?: string = '';
  otherdobDt: string = '';
  parish: string = '';
  display: any;
  alreadySubmitted:boolean=false;

  checkCaptch(event: any) {
    if (
      this.captchaEntered != '' &&
      this.captchaEntered != this.captchaText
    ) {
      this.captcha.control.setErrors({ nomatch: true });
      return false;
    } else {
      this.captcha.control.setErrors(null);
      return true;
    }
  }

  submit() {
    if (this.captchaEntered == '') {
      return;
    } else if (this.captchaEntered != this.captchaText) {
      return;
    }

    if(this.memberPierId == null && this.formNc.referralMemberList.length > 0){

      this.formNc.referralMemberList.forEach(mem => {
        if (mem.memberPierId != null){
          this.otherMemberPierId=  mem.memberPierId;
          mem.memberPierId = null;
        }

      });
    }else if(this.memberPierId == null && this.formNc.referralMemberList.length == 0 ){
      this.otherMemberPierId=  null;
    }

    if (this.existingMember == 'Yes' || (this.formNc.referralMemberList.length > 0 && this.existingOtherMember == 'Yes')) {
      this.formNc.referralCase.existingCase = true;
      this.formNc.referralCase.pierId = this.memberPierId!=null? this.memberPierId: this.otherMemberPierId;
    }



    if (this.existingMember == 'Yes') {
      // this.memberObj1.existingMember = true;
      this.formNc.referralCase.updateReason = this.updateReason;
    }
     this.formNc.referralCase.useAch = this.signDepositeCheck ==true;
     this.formNc.referralCase.emailSignup = this.signReadEmailCheck ? true : false;
    if(this.signDepositeCheck && this.formNc.referralAccount != null){
      this.formNc.referralAccount.nameOnBankAccount = this.accountHolderName;
      this.formNc.referralAccount.accountNumber = this.depositAccountNum;
      this.formNc.referralAccount.accountType = this.accountType;
      this.formNc.referralAccount.bankName = this.depositBankName;
      this.formNc.referralAccount.routingNumber = this.depositRoutingNum;
    }else{
      this.formNc.referralAccount=null;
    }

    if(this.isSameMailingAddress =='Yes'){
      this.mailAddressFormControl.patchValue(this.resAddressFormControl.getRawValue())
    }
    this.formNc.referralAddressList.push(<ReferralAddress>this.resAddressFormControl.getRawValue());
    if(this.isSameMailingAddress=='No'){
      this.formNc.referralAddressList.push(<ReferralAddress>this.mailAddressFormControl.getRawValue());
    }
    this.memberObj1.dobDt = this.getServerDate(this.memberVOdobDt);

    this.formNc.referralEmployer.openEnrollmentStartDate=this.getServerDate(
      this.openenrollmentstartdate
    );
    this.formNc.referralEmployer.openEnrollmentEndDate=this.getServerDate(
      this.openenrollmentenddate
    );
    this.formNc.referralPolicy.policyStartDate = this.getServerDate(
      this.policyVOpolicyStartDate
    );

    if (
      this.isFamilyMemberMedicate == 'No' &&
      this.formNc.referralMemberList.length > 0
    ) {
      this.formNc.referralMemberList = [];
    }
    this.formNc.referralMemberList.push(this.memberObj1);
    this.formNc.referralMemberList?.forEach( (object)=> {
      if(object.ssnNum!='' ){
        object.ssnNum =object.ssnNum.replaceAll('-','');
        object.memberPierId = null;
      }
    });

    let premiumAmt =this.formNc.referralPolicy.employeePremium;
    if(premiumAmt =='')
    premiumAmt ='0';
    this.formNc.referralPolicy.employeePremium=parseFloat(premiumAmt!).toFixed(2);

    this.memberObj1.enrolledInPolicy = this.isMemberMedicaid == 'Yes';
    this.memberObj1.recipientPerson = this.isMemberMedicaid == 'Yes';

    let frequency =this.formNc.referralPolicy.frequency;
    if(frequency =='' || frequency =='0.00')
    frequency ='0';
    this.formNc.referralPolicy.frequency=frequency;


    let mempierid=this.formNc.referralCase.pierId;
    if(mempierid=='' || mempierid == null){
      mempierid='0';
      this.formNc.referralCase.pierId=mempierid;
      this.formNc.referralCase.pierId = '0';
      this.formNc.referralCase.existingCase = false;
      } else {
        this.formNc.referralCase.pierId =mempierid;
      }

    let planDeductible =this.formNc.referralPolicy.planDeductible;
    if(planDeductible =='') planDeductible = '0';
    this.formNc.referralPolicy.planDeductible=parseFloat(planDeductible!).toFixed(2);

    let individualMaxDeduct =this.formNc.referralPolicy.individualMaxDeductible;
    if(individualMaxDeduct =='') individualMaxDeduct = '0';
    this.formNc.referralPolicy.individualMaxDeductible=parseFloat(individualMaxDeduct!).toFixed(2);

    let familyMaxDeduct =this.formNc.referralPolicy.familyMaxDeductible;
    if(familyMaxDeduct =='') familyMaxDeduct = '0';
    this.formNc.referralPolicy.familyMaxDeductible=parseFloat(familyMaxDeduct!).toFixed(2);


    this.formNc.referralCase.phone1Num= this.formNc.referralCase.phone1Num?.replaceAll('-','');
    this.formNc.referralCase.phone2Num= this.formNc.referralCase.phone2Num?.replaceAll('-','');
    this.formNc.referralPolicy.phoneNum=this.formNc.referralPolicy.phoneNum?.replaceAll('-','');
    this.formNc.referralEmployer.phoneNum=this.formNc.referralEmployer.phoneNum?.replaceAll('-','');
    this.formNc.referralEmployer.faxNum=this.formNc.referralEmployer.faxNum?.replaceAll('-','');
    this.formNc.referralEmployer.emplyrFein=this.formNc.referralEmployer.emplyrFein?.replaceAll('-','');
    this.formNc.referralEmployer.zipCd=this.formNc.referralEmployer.zipCd?.replaceAll('-','');
    this.formNc.referralAddressList?.forEach( (object)=> {
      if(object.zipCd!='' ){
        object.zipCd =object.zipCd?.replaceAll('-','');
      }
    });
    this.formNc.referralPolicy.zipCd=this.formNc.referralPolicy.zipCd?.replaceAll('-','');
if(!this.alreadySubmitted){
  this.alreadySubmitted =true;


    this.dataService.insertCustomerForm(this.formNc).subscribe({ next:
      (response: ResponseDTO) => {
        if (response) {
          // Mark form as pristine so that CanDeactivateGuard won't prompt before navigation
          //this.referral.memberVOLst.pop();
          this.isValidFormSubmitted = true;
          this.submittedResponse=response;
          //console.log('ResponseId: '+insertedCustomer.reponseID)
          //this.router.navigate(['/customers']);
         clearInterval(this.timer);
         let addMins:number=0;
         addMins  = 15 - this.seconds/60;
         this.timerStart(addMins);


        } else {
          this.formNc.referralMemberList.pop();
          const msg = 'Unable to save customer details';
          this.errorMessage = msg;
        }
        window.scrollTo(0, 0);
      }, error:
      (err: HttpErrorResponse) => {this.logger.log(err.message);
        this.apiError = err;
        this.warningMessage = '';
        const msg = 'We are unable to save application details currently, please contact customer support.';
        this.errorMessage = msg;
        window.scrollTo(0, 0);
        this.isValidFormSubmitted = true;
        setTimeout(() => {
          this.errorMessage ='';
        }, 3000);
      }
});


    if (this.errorMessage != '') {
      window.scrollTo(0, 0);
      this.customerForm?.resetForm();
    }
  }
  }

routingNumberValidator(routingNum: any, control: NgModel) {
    this.phoneCheck(routingNum, control);
    const routingNumber = routingNum.target.value;
    if (routingNumber.length == 9) {
      const weights = [3, 7, 1];
      let sum = 0;
      for (let i = 0; i < routingNumber.length; i++) {
        sum += parseInt(routingNumber[i], 10) * weights[i % 3];
      }

      if (sum % 10 === 0) {
        if (control.control.errors) delete control.control.errors['invalid'];
        this.isRoutingNumberValid= true;
      } else {
        control.control.setErrors({ ...(control.errors || {}), invalid: true });
        this.isRoutingNumberValid= false;
      }
    }
  }

  isMedicaidValid(medicaid: any, control: NgModel){
    let isValid = ValidationService.isMedicaidValid(medicaid.target.value);
    if(!isValid){
      control.control.setErrors({...(control.errors || {}),'invalid': true});

    }else{
      if(control.control.errors)
      delete  control.control.errors['invalid'];

    }
  }
  addFamilyMember(event: Event) {
    this.addClearFamilyFilled =false;
    let valid =true;
    const form = this.customerForm?.form;

    if(form != null){
      let page1 =['isFamilyMemberMedicate','otherfirstNm','othermiNm','otherlastNm','othermaNum',
      'otherssnNum','d6','othergencdRf','d7','otherrshcdRf','otherEnrolled','MedicalHealthCondition'];
      for (let key of page1) {
        if(form.controls[key]?.errors !=null){
          valid =false;
        }
      }

      }

      if(this.othergencdRf=='M'){
        this.otherMemberDueDate = null;
      }
      if(this.formNc.referralMemberList.length>50){
        this.additionalMaxReached =true;
      }

      if (valid && !this.additionalMaxReached) {
        (event.target as HTMLButtonElement).disabled = true;

      if (
        (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
          this.otherfirstNm != '' &&
          this.otherlastNm != '' &&
          this.othergencdRf != '' &&
          this.otherrshcdRf != '' &&
          this.otherEnrolled != '' &&
          this.otherssnNum != '' &&
          this.othermaNum != '' 
      ) {
      if (this.memberObj1.ssnNum == this.otherssnNum) {
        this.ssnValidationError = 'Duplicate ssn in the form';
        this.otherSsn.control.setErrors({ duplicate: true });
        return;
      }
      this.addFamilyMemberButton= true;
      if (this.editIndex != undefined){
        this.formNc.referralMemberList.splice(this.editIndex, 1);
        this.editIndex = undefined;
      }
      let otherMembPierId: string |null =null;
      if(this.memberPierId == null && this.formNc.referralMemberList.length > 0){

        this.formNc.referralMemberList.forEach(mem => {
          if (otherMembPierId == null && mem.memberPierId != null){
            otherMembPierId=  mem.memberPierId;
          }
        });
      }

        this.verifyMember.dobDt = this.getServerDate(this.otherdobDate);
        this.verifyMember.ssnNum = this.otherssnNum;
        this.verifyMember.pierId = this.memberPierId != null? this.memberPierId: otherMembPierId;
        this.verifyMember.firstNm = this.otherfirstNm;
        this.verifyMember.lastNm = this.otherlastNm;

        this.verifyMember.ssnNum =this.verifyMember.ssnNum.replaceAll('-', '')

        this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
          next: (response: verifyMemberResponse) => {
            if (response) {
              if (response.addMember == true && response.existingMember == true && response.pierId != null) {
                this.otherMemberPierId = response.pierId;
                this.existingOtherMember = 'Yes';
              }
              this.addMember = response.addMember;
            }
        if (!this.addMember) {
              this.existingInvalidMemberName =
                this.verifyMember.firstNm + ' ' + this.verifyMember.lastNm;
              this.addFamilyMemberButton = false;
              this.openValidateMemberDialog();
              return;
        }else{
          if(this.otherfirstNm !='' && this.otherlastNm != '' && this.otherssnNum !=''){
            this.formNc.referralMemberList.push({
              dobDt: this.getServerDate(this.otherdobDate),
              firstNm: this.otherfirstNm,
              lastNm: this.otherlastNm,
              miNm: this.othermiNm,
              ssnNum: this.otherssnNum,
              maNum: this.othermaNum,
              genderCd: this.othergencdRf,
              relationshipCd: this.otherrshcdRf,
              enrolledInPolicy: this.otherEnrolled=='Yes',
              recipientPerson : this.otherEnrolled == 'Yes',
              existingMember: this.existingOtherMember == 'Yes',
              medicalCondition: this.medicalCondition,
              memberPierId: this.otherMemberPierId
            });
          }
            this.checkAdditionalMembers();
            this.additionalMembersReq = false;
            this.addClearFamilyFilled = false;
            this.clear(event);
            this.otherdobDate = null;
            this.otherdobDt = '';
            this.otherfirstNm = '';
            this.otherlastNm = '';
            this.othermiNm = '';
            this.otherssnNum = '';
            this.othermaNum = '';
            this.othergencdRf = '';
            this.otherrshcdRf = '';
            this.otherMemberDueDate = null;
            this.medicalCondition ='';
          }
        }, error: (err: HttpErrorResponse) => {
          this.logger.logMsg(err.error);
          const msg = 'We are unable to verify Member details currently, please contact customer support at (877) 697-6703';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },

      });

    } else {
      if (this.otherfirstNm == '') {
        this.otherFnRequired = true;
      }
      if (this.otherlastNm == '') {
        this.otherLnRequired = true;
      }
      if(this.othermaNum == ''){
        this.othermaNumRequired = true;
      }
      if(this.otherEnrolled == ''){
        this.otherEnrolledRequired=true;
      }
      if (this.otherssnNum == '') {
        this.otherSsnRequired = true;
      }
      if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
        this.otherDobRequired = true;
      }

      if (this.othergencdRf == '') {
        this.otherGnRequired = true;
      }
      if (this.otherrshcdRf == '') {
        this.otherRsRequired = true;
      }
    }
    (event.target as HTMLButtonElement).disabled = false;
    }
    else {
      if (this.otherfirstNm == '') {
        this.otherFnRequired = true;
      }
      if (this.otherlastNm == '') {
        this.otherLnRequired = true;
      }
      if(this.othermaNum == ''){
        this.othermaNumRequired = true;
      }
      if(this.otherEnrolled == ''){
        this.otherEnrolledRequired=true;
      }
      if (this.otherssnNum == '') {
        this.otherSsnRequired = true;
      }
      if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
        this.otherDobRequired = true;
      }

      if (this.othergencdRf == '') {
        this.otherGnRequired = true;
      }
      if (this.otherrshcdRf == '') {
        this.otherRsRequired = true;
      }
    }
  }

  clear(event: Event) {
    this.goBack3();
    this.addClearFamilyFilled =false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.othermaNumRequired = false;
    this.otherEnrolledRequired=false;
    this.otherSsnRequired = false;
    this.otherDobRequired = false;
    this.otherGnRequired = false;
    this.otherRsRequired = false;
    this.otherdobDt = '';
    this.otherfirstNm = '';
    this.othermaNum = '';
    this.otherlastNm = '';
    this.othermiNm = '';
    this.otherssnNum = '';
    this.medicalCondition = '';
    this.othergencdRf = '';
    this.otherrshcdRf = '';
    if(this.otherDob && this.otherDob.control){
      this.otherDob.control.setValue('');
      this.otherDob.control.setErrors(null);
    }
    this.otherMemberDueDate = null;
    this.otherEnrolled = '';
    this.addMember = true;
    this.addFamilyMemberButton = false;
  }
  cancel(event: Event) {
    event.preventDefault();
    this.changeResetMessage();
    window.scrollTo(0, 0);
  }

  removeMember(memberIndex: number): void {
    const [removedUser] = this.formNc.referralMemberList.splice(memberIndex, 1);
    if (this.formNc.referralMemberList.length == 0) {
      this.additionalMembersReq = true;
    }
    if (this.formNc.referralMemberList.length <= 50) {
      this.additionalMaxReached = false;
    }

    if(removedUser?.existingMember && removedUser.memberPierId) {
      this.otherMemberPierId = null;
      this.existingOtherMember = 'No';
    }

  }

  editMember(memberIndex: number): void {
    let obj = this.formNc.referralMemberList[memberIndex];
    this.editIndex=memberIndex;
    this.otherfirstNm = obj.firstNm;
    this.otherlastNm = obj.lastNm;
    this.otherssnNum = obj.ssnNum;
    this.othermaNum= obj.maNum;
    this.medicalCondition= obj.medicalCondition;
    this.othermiNm=obj.miNm;
    this.othergencdRf = obj.genderCd;
    this.otherrshcdRf = obj.relationshipCd;
    this.otherdobDate = moment(obj.dobDt, "MM/DD/YYYY").toDate();
    this.otherEnrolled=obj.enrolledInPolicy?'Yes':'No';
      this.otherMemberDueDate=null;
  }
  getServerDate(dateStruct: Date | null) {
    if (dateStruct != null) {
      return this.datePipe.transform(dateStruct, 'MM/dd/yyyy');
    }
    return null;
  }
  public changeSuccessMessage() {
    this._success.next(`${new Date()} - Form submitted successfully.`);
  }
  public changeResetMessage() {
    this._warning.next(` Form reset done.`);
  }
  allowAlphabets(event: any) {
    return ValidationService.allowAlphabets(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphabets2(event: any, control: NgModel) {
    return ValidationService.allowAlphabets2(
      event,
      this.deviceDetectorService.browser, control
    );
  }
  allowAlphaNumericWithSplChars(event: any,control: NgModel){
    return ValidationService.allowAlphaNumericWithSplChars(
      event,
      this.deviceDetectorService.browser,
      control
    );


  }
  allowAlphaNumericWithTwoSplChar(event: any, control: NgModel){
    return ValidationService.allowAlphaNumericWithTwoSplChar(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericForCarrier(event: any, control: NgModel){
      return ValidationService.allowAlphaNumericForCarrier(
        event,
        this.deviceDetectorService.browser,
        control
      );
  }
  allowAlphaNumericWithoutSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithoutSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericWithSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithSpace(
      event,
      this.deviceDetectorService.browser, control
    );
  }

  isNumeric(elem: any, control: NgModel) {
    return ValidationService.isNumeric2(elem, this.deviceDetectorService.browser, control);
  }

  oneSpaceAllowed(event: any) {
    return ValidationService.oneSpaceAllowed(event);
  }

  allowAlphaNumeric(event: any) {
    return ValidationService.allowAlphaNumeric(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphaNumericWithSplHash(event: any) {
    return ValidationService.allowAlphaNumericWithSplHash(
      event,
      this.deviceDetectorService.browser
    );
  }

  validatePremiumAmount(amount: any,control: NgModel) {
    return ValidationService.validatePremiumAmount(amount,control);
  }

  validatePremiumAmountFormat(event: any){
    return ValidationService.validatePremiumAmountFormat(event,
      this.deviceDetectorService.browser);
  }
  ssnmask(ssn: any, control: NgModel) {
    return ValidationService.ssnmask(ssn, control);
  }

  async setDefaultBlank(event: any, controlName: string, formGroup: FormGroup, propName: string){
    let cityTxt =formGroup.controls['cityTxt'];
    let stateCd =formGroup.controls['stateCd'];
    let zipCd =formGroup.controls['zipCd'];
    const key = event.keyCode || event.charCode;
    if(this.addressSuggestions[propName].length >0 && event.target.value.length < 6){
      this.addressSuggestions[propName] = [];
    }
   
  if((event.ctrlKey && event.key === 'v') || (event.ctrlKey && event.key === 'c') || key != 37 && key != 38 && key != 39 && key != 40 && event.keyCode!=13 && event.keyCode!= 9){     
    if(cityTxt.value !='' || stateCd.value !='' || zipCd.value !='' || key === 8 || key === 46  ||(event.ctrlKey && event.key === 'x')){
      
       if(controlName =='mailAddress.address1Txt'){
         this.showMailAddress=false;
       }else if(controlName =='caseVO.address1Txt'){
       this.showResAddress=false;
       } else if(controlName =='employerVO.address1Txt') {
         this.showEmployerAddress = false;
       } else if(controlName =='policyVO.addressLine1Txt') {
         this.showPolicyAddress = false;
       }
       formGroup.patchValue({
        address2Txt: '',
         cityTxt: '',
         stateCd: '',
         zipCd: ''
       });
     }
     if(controlName =='caseVO.addressLine1Txt' && this.resAddressFormControl.value?.address1Txt?.includes('PO BOX')){
       this.resAddressFormControl.setErrors({'po': true});
     }
   }

 }

 selectSuggestion(fromGroup: FormGroup,name:string, control: FormControl, suggestion: any, trigger: any, propName: string) {
      if(suggestion?.option?.value?.secondary && suggestion?.option?.value?.entries > 1 ){
        this.disableSearch = true;
        const selectedAddress = suggestion?.option?.value?.street_line +' '+ suggestion?.option?.value?.secondary + ' ('+suggestion?.option?.value?.entries + ') '+
        suggestion?.option?.value?.city +' '+ suggestion?.option?.value?.state +' '+ suggestion?.option?.value?.zipcode;
        control.setValue(suggestion?.option?.value?.street_line.toUpperCase());

        this.addressSuggestions[propName] = [];
        this.setPreviousVal(suggestion?.option?.value?.street_line, propName);
        this.addressService.autocompleteSelectedAddress(suggestion?.option?.value?.street_line.toUpperCase(), selectedAddress).then(
          (data:any)=> {
            this.addressSuggestions[propName] = data.suggestions;
            if(trigger) {
              trigger.openPanel();
            }
            setTimeout (() => {
              this.disableSearch = false;
            },9000)

          }
        )

        console.log("Address Suggestions: "+this.addressSuggestions);
      }  else{
        const address: ReferralAddress = {
          addressType: '',
          address1Txt: '',
          address2Txt: '',
          cityTxt: '',
          stateCd: '',
          zipCd: '',
        };
        this.addressSuggestions[propName] = [];
        control.setValue(suggestion?.option?.value?.street_line.toUpperCase());
        if(name =='mailAddress.address1Txt'){
          address.addressType = 'M';
          this.showMailAddress=true;
          this.addressService.setAddressDetails(address,suggestion);
          this.mailAddressFormControl.patchValue(address);
        } else if(name =='employerVO.address1Txt'){
          this.showEmployerAddress=true;
          this.addressService.setAddressDetails(address,suggestion);
          this.referralEmployerAddressFormControl.patchValue(address);
          this.formNc.referralEmployer = {...this.formNc.referralEmployer, ...address, address1Txt: address.address1Txt, address2Txt: address.address2Txt };
        } else if(name =='policyVO.addressLine1Txt'){
          this.showPolicyAddress = true;
          this.addressService.setAddressDetails(address,suggestion);
          this.referralPolicyAddressFormControl.patchValue(address);
          this.formNc.referralPolicy = {...this.formNc.referralPolicy, ...address, addressLine1Txt: address.address1Txt, addressLine2Txt: address.address2Txt };
        } else if(name =='caseVO.address1Txt'){
          address.addressType = 'R';
          this.showResAddress=true;
          this.addressService.setAddressDetails(address,suggestion);
          this.resAddressFormControl.patchValue(address);
        }
      }
}


  getKeyByValue(object: Record<string, string>, value: string): string | undefined {
    return Object.keys(object).find(key => object[key] === value);
  }

validateAdress(address: ReferralAddress, formGroup: FormGroup, suggestionCount: number, force = true) {
  let valid = true;
  if(!address.address1Txt){
    formGroup.controls['address1Txt'].setErrors({
      required: true
    });
    valid = false;
  } else {
    console.log('suggestionCount', suggestionCount , address.zipCd);
      if(force && suggestionCount === 0 && !address.zipCd){
        formGroup.controls['address1Txt'].setErrors({
          invalid: true
        });
        valid = false;
      }
      else {
        formGroup.controls['address1Txt'].setErrors(null);
      }
  }

  if(!address.stateCd){
    formGroup.controls['stateCd'].setErrors({
      required: true
    });
    valid = false;
  } else {
    formGroup.controls['stateCd'].setErrors(null)
  }
  if(!address.zipCd){
    formGroup.controls['zipCd'].setErrors({
      required: true
    });
    valid = false;
  } else {
    formGroup.controls['zipCd'].setErrors(null)
  }
  if(!address.cityTxt){
    formGroup.controls['cityTxt'].setErrors({
      required: true
    });
    valid = false;
  } else {
    formGroup.controls['cityTxt'].setErrors(null)
  }
  return valid;
}

  phonemask2(phone: any, control: NgModel) {
    return ValidationService.phonemask2(phone, control);
  }

  datemask2(date: any, control: NgModel) {
    return ValidationService.datemask2(date,control);
  }
  onlyNumeric(elem: any, control: NgModel) {
    return ValidationService.onlyNumeric(
      elem,
      this.deviceDetectorService.browser,
      control
    ); 
  }
  isFEINValidValue(empFEIN: any, control: NgModel){
    let isValid = ValidationService.isFEINValidValue(empFEIN.target.value);
    if(!isValid){
      control.control.setErrors({...(control.errors || {}),'invalid': true});

    }else{
      if(control.control.errors)
      delete  control.control.errors['invalid'];

    }
  }
  empFEINMask(empFEIN: any,control: NgModel){
    return ValidationService.empFEINMask(empFEIN,control);
  }
  amountMask(amount: any,control: NgModel){
    return ValidationService.amountMask(amount,control);
  }
  validateAmount(amount: any,control: NgModel) {
    return ValidationService.validateAmount(amount,control);
  }

  getSSNUsedMessage() {
    return ValidationService.getSSNUsedMessage2( this.faxNo);
  }
  getMessageServerDown() {
    return ValidationService.getMessageServerDown();
  }


  verifySSN(event: any, isOtherSsn: boolean) {
    let ssn = event.target.value;
    let donepatt = /^(\d{3})-(\d{2})-(\d{4})$/;
    if (ssn.match(donepatt)) {
      let check: boolean = ValidationService.isSSNValidValue(ssn);
      if (!check) {
        if (!isOtherSsn) {
          this.MemberSsn.control.setErrors({...(this.MemberSsn.control.errors || {}), invalidSsn: true });
          return false;
        }
        if (isOtherSsn) {
          this.otherSsn.control.setErrors({...(this.otherSsn.control.errors || {}),invalidSsn: true });
          return false;
        }
      }

      if (isOtherSsn && this.memberObj1.ssnNum == ssn) {
        this.ssnValidationError = 'Duplicate ssn in the form';
        this.otherSsn.control.setErrors({...(this.otherSsn.control.errors || {}), duplicate: true });
        return false;
      }

      for (let othermember of this.formNc.referralMemberList) {
        if (isOtherSsn && othermember.ssnNum == ssn && (this.editIndex == undefined || this.getIndexByName(ssn) !==this.editIndex )) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({...(this.otherSsn.control.errors || {}), duplicate: true });
          return false;
        }
      }

      // If we reach here, SSN is valid and matches the pattern
      return true;
    }

    return false;
  }
  getIndexByName(name: string): number {
    return this.formNc.referralMemberList.findIndex(item => item.ssnNum === name);
  }


  policyHolderCheck() {

    const resAddress = this.resAddressFormControl.getRawValue();
    const mailAddress = this.mailAddressFormControl.getRawValue();

    let requiredFields: boolean =  this.existingMember != '' &&
    ((this.existingMember == 'No' &&  this.formNc.referralCase.referralSource != '') ||
      (this.existingMember == 'Yes' && this.updateReason != ''))
    && ((this.signReadEmailCheck &&  this.formNc.referralCase.emailTxt != '') || (!this.signReadEmailCheck))
    && this.memberObj1.firstNm != ''
    && this.memberObj1.lastNm != ''
    && this.memberObj1.ssnNum != ''
    &&this.memberObj1.genderCd!=''
    && this.memberVOdobDt != null
    && (this.isMemberMedicaid == 'No' || (this.isMemberMedicaid =='Yes'&& this.memberObj1.maNum !=''))
    &&((resAddress.address1Txt !='' &&  resAddress.stateCd !='' && resAddress.zipCd !='' && resAddress.cityTxt !='' && this.isSameMailingAddress !='')
    &&(this.isSameMailingAddress == 'No' &&  mailAddress.address1Txt !='' && mailAddress.stateCd !='' && mailAddress.zipCd !='' && mailAddress.cityTxt !='' || (this.isSameMailingAddress =='Yes' )));


    let valid =true;
      const form = this.customerForm?.form;
    if(requiredFields && form != null){
      let page1 =['caseVO.referralSource','memberVO.firstNm','memberVO.miNm','memberVO.lastNm','memberObj.ssnNum','d1','memberVO.gencdRf','isMemberMedicaid','caseVO.addressLine1','caseVO.addressLine2','resparish','caseVO.cityTxt','caseVO.stacdRf','caseVO.zip5Cd','caseVO.phone1Num', 'caseVO.phone2Num','caseVO.emailTxt','isSameMailingAddress','mailAddress.addressLine1','mailAddress.addressLine2','mailAddress.cityTxt','mailAddress.stacdRf','mailing.zip5Cd','mailingState.phone1Num','homeLessEmailTxt','homeLessPhone1Num','existingMember','updateReason','d2',];
      for (let key of page1) {
        if(form.controls[key]?.errors !=null){
          valid =false;
        }
      }

      }

      return requiredFields && valid;
  }

  employerPolicyCheck() {
    let requiredFields: boolean= this.policyHolderCheck()
    && this.checkPage2Valid()
    && this.formNc.referralPolicy.policySourceCd != '' &&
    ((this.existingMember == 'Yes' &&  this.formNc.referralPolicy.employeePremium != '' &&
      this.formNc.referralPolicy.premiumPaidOption!='' &&
    this.formNc.referralPolicy.individualMaxDeductible!='' && this.formNc.referralPolicy.familyMaxDeductible!=''
     &&  this.formNc.referralPolicy.planTier != '' &&
    this.formNc.referralPolicy.frequency != '')||  (this.existingMember == 'No' &&
        this.formNc.referralEmployer.emplyrNm != '' &&
        this.formNc.referralEmployer.address1Txt != '' &&
        this.formNc.referralEmployer.cityTxt != '' &&   this.formNc.referralEmployer.stateCd != '' &&
        this.formNc.referralEmployer.zipCd != '' &&  this.formNc.referralEmployer.phoneNum != '' &&
        this.formNc.referralEmployer.emplyrFein != ''
        && this.openenrollmentstartdate!=null  && this.openenrollmentenddate!=null
      )) ;

     let valid =true;
     const form = this.customerForm?.form;
      if(requiredFields && form != null){
        let page1 =['isHealthInsurance','employerVO.emplyrNm','employerVO.address1Txt','employerVO.address2Txt','employerVO.cityTxt','employerVO.stacdRf','employerVO.zip5Cd','employerVO.phoneNum','employerVO.hrContactName','employerVO.faxNum','employerVO.emplyrFein','policyVO.carrierNm','policyVO.addressLine1Txt','policyVO.addressLine2Txt','policyVO.cityTxt','policyVO.stacdRf','policyVO.zip5Cd','policyVO.phoneNum','policyVO.planNm','policyVO.policyNum','policyVO.groupNum','d3','premium', 'policyVO.frequency', 'policyVO.planTier'];
        for (let key of page1) {
          if(form.controls[key]?.errors !=null){
            valid =false;
          }
        }

        }

      return requiredFields && valid;
  }

 familyMemberCheck() {
  let requiredFields:boolean =
        this.policyHolderCheck() &&
        this.employerPolicyCheck() &&
        this.isFamilyMemberMedicate != '' &&
        (this.checkAdditionalMembers() && (this.isFamilyMemberMedicate != '') ||
        (this.isFamilyMemberMedicate == 'No'));

    let valid =true;
    const form = this.customerForm?.form;

    if(requiredFields && form != null){
      let page1 =['isFamilyMemberMedicate','otherfirstNm','othermiNm','otherlastNm','othermaNum',
      'otherssnNum','d6','othergencdRf','d7','otherrshcdRf','otherEnrolled'];
      for (let key of page1) {
        if(form.controls[key]?.errors !=null){
          valid =false;
        }
      }

      }
      let checkFmailyFilled: boolean =false;
      if(this.otherfirstNm !='' && this.otherlastNm != '' && (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') && this.otherEnrolled !=''  && this.othermaNum != ''){
        checkFmailyFilled = true;
       }else{
        checkFmailyFilled = false;
       }

       return (
        requiredFields &&
        valid &&
        !checkFmailyFilled &&
        !(this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No')
      );
  }
  checkAdditionalMembers(){

    if(this.isFamilyMemberMedicate == 'Yes' && this.formNc.referralMemberList.length == 0 ){
      return false;
    }
    else{
      return true;
    }

  }


  rightsResponsibilityCheck() {
    return this.policyHolderCheck()
      && this.employerPolicyCheck()
      && this.familyMemberCheck()
      && this.signReadCheck;
  }

  directDeposit(){
    this.accountHolderName = '',
    this.accountType ='';
    this.depositBankName ='';
    this.depositRoutingNum='';
    this.depositAccountNum='';
    this.accountHolderNameRequired = false;
    this.depositBankNmRequired =false;
      this.routingNumRequired=false;
      this.accountNumRequired=false;
      this.accountTypeRequired=false;

  }

  directDepositCheck() {
    return (this.policyHolderCheck()
      && this.employerPolicyCheck()
      && this.familyMemberCheck()
      && this.rightsResponsibilityCheck()
      &&( !this.signDepositeCheck || (this.signDepositeCheck && this.directDepositFn()))
      && this.isRoutingNumberValid
    );
  }
  directDepositFn(): boolean {
    const routingCtrl = this.customerForm?.form.controls['deposit.routingNum'];

    if (this.routingNumberNgModel) {
    this.routingNumberValidator(
      { target: { value: this.depositRoutingNum } },
      this.routingNumberNgModel
    );
    }
    let requiredFields: boolean =  this.familyMemberCheck() &&
    this.accountHolderName !='' &&
    this.depositAccountNum != '' && this.accountType != '' &&
    this.depositBankName != '' && this.depositRoutingNum != '' && routingCtrl.valid;

  let valid = true;
  const form = this.customerForm?.form;
  if (requiredFields && form != null) {
    let page1 = [ 'accountType', 'deposit.accountNum', 'deposit.routingNum','deposit.bankName','deposit.accountHolderName' ];;
    for (let key of page1) {
      if (form.controls[key]?.errors != null) {
        valid = false;
        break;
      }
    }
  }

  return requiredFields && valid;
  }


  submitCheck() {
    let requiredFields:boolean = this.policyHolderCheck()
      && this.employerPolicyCheck()
      && this.familyMemberCheck()
      && this.rightsResponsibilityCheck()
      && this.directDepositCheck()
      && this.signElectronicSignatureChecked
      && this.formNc.referralCase.submitterFirstName != ''
      && this.formNc.referralCase.submitterLastName != ''
      && this.captchaEntered != '';

      let valid =true;
     const form = this.customerForm?.form;
      if(requiredFields && form != null){
        let page1 =['signElectronicSignatureChecked','signApplicant','signfirstNm','signLastName','captcha'];
        for (let key of page1) {
          if(form.controls[key]?.errors !=null){
            valid =false;
          }
        }
      }

      return requiredFields && valid;
  }
  seconds: number = 0;
  timer: any;
  timerStart(minute: number) {


    if(this.seconds > 0){
      this.seconds = this.seconds + minute * 60;
    }else{
      this.seconds = minute * 60;
    }
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = Math.floor(this.seconds / 60) < 10 ? "0" : "";

     this.timer = setInterval(() => {
      this.seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;



      textSec = statSec.toString().padStart(2, '0');
      let minutes = (Math.floor(this.seconds / 60)).toString().padStart(2,'0');
      this.display = `${minutes}:${textSec}`;
      if (this.seconds == 60 && !this.isValidFormSubmitted) {
        this.openDialog();
      }
      if (this.seconds == 0) {
        console.log("finished");
        window.scrollTo(0, 0);
       // window.location.reload();
        clearInterval(this.timer);
      }
    }, 1000);
  }

  checkEmail(){
    this.signCheckEmailRequired = false;
   }

   validateAddress(address1Txt: any, city: any, state: any, zipCd: any){
    if(address1Txt.value != ''){
      if( city.value =="" || state.value =="" || zipCd.value ==""){
        if(!(address1Txt.errors && address1Txt.hasError('po')))
        address1Txt.setErrors({...(address1Txt.errors || {}),'invalid': true,});
      }else{
        if(address1Txt.errors && address1Txt.hasError('invalid'))
          delete  address1Txt.errors['invalid'];
      }
    }else if(address1Txt.errors && !address1Txt.hasError('required')){
      address1Txt.setErrors(null);
    }
  }
  
  phoneCheck(event : any, control: NgModel ){
    if(event.target.value =='' && control.control.errors && (control.control.hasError('nomatch') || control.control.hasError('pattern'))){
      control.control.setErrors(null);
    }
  }

  isMedicaidMember() {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.memberObj1.maNum = '';
    this.maNumRequired = false;
    this.memberVODuedate = null;
  }

  openMedicaidDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Medicaid Member Required',
        content: `<br />
      <p>At least one member of your family should be a Medicaid recipient to apply for HIPP. <br />Based on your responses, you do not qualify for HIPP.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }

  sameMailingAddress(){

    this.mailAddressFormControl.patchValue({
      address1Txt: '',
      address2Txt: '',
      stateCd: '',
      zipCd: '',
      cityTxt: ''
    })

      // this.mailAddress.address1Txt ='';
      // this.mailAddress.address2Txt ='';
      // this.mailAddress.stateCd ='';
      // this.mailAddress.zipCd ='';
      // this.mailAddress.cityTxt ='';

      this.showMailAddress=false;
      this.mailAddress1Required = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;

  }

  openDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
     data: {
        title: 'Session Timer',
        content:  `<br />
        <p>Your session is about to end, and your changes will not be saved. </p>
        <p> Would you like to extend your session?</p>
        <br />`,
        confirmButtonText: ''},
      disableClose: true });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if(result){
        clearInterval(this.timer);
        this.timerStart(15);
      }else if(result==false){
        this.changeResetMessage();
        window.scrollTo(0, 0);
      }
    } );


  }

  allowAlphaNumericWithSplChar(event: any) {
    return ValidationService.allowAlphaNumericWithSplChar(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowOnlyOneAlphabet(event: any,control: NgModel) {
    return ValidationService.allowOnlyOneAlphabet(
      event,
      this.deviceDetectorService.browser,control
    );
  }
  openPdf() {
    let bytes = this.submittedResponse.submittedApplication;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.title = 'Submitted Form';
    anchor.ariaLabel = 'Submitted Form';
    anchor.lang = 'en';
    anchor.type = 'application/pdf';
    anchor.download = this.submittedResponse.referralId + '.pdf';
    anchor.click();
  }
  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  removeSavedFamilyMembers(event: any) {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.formNc.referralMemberList = [];
    this.additionalMaxReached = false;
    this.additionalMembersReq = false;

    this.clear(event);
  }



  verifyMemberFn(){
    let requiredFields:boolean = this.memberObj1.firstNm != ''
      && this.memberObj1.lastNm != ''
      && this.memberObj1.ssnNum != ''
      && this.memberVOdobDt != null;

      if(!requiredFields){
        this.firstNameRequired = true;
        this.lastNameRequired = true;
        this.ssnMemberRequired = true;
        this.memberDobRequired = true;
      }

    let valid =true;
        const form = this.customerForm?.form;

       if(requiredFields && form != null){
        let page1 =['memberVO.firstNm','memberVO.lastNm','memberObj.ssnNum','d1'];
        for (let key of page1) {
          if(form.controls[key]?.errors !=null){
            valid =false;
          }
        }
      }

      if (requiredFields && valid) {
        this.existingMemberFn()
        this.verifyMember.firstNm = this.memberObj1.firstNm;
        this.verifyMember.lastNm = this.memberObj1.lastNm;
        this.verifyMember.dobDt = this.getServerDate(this.memberVOdobDt);
        this.verifyMember.ssnNum = this.memberObj1.ssnNum;
        this.verifyMember.pierId = this.memberPierId;

        this.verifyMember.ssnNum =this.verifyMember.ssnNum.replaceAll('-', '')
        this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({ next: (response: verifyMemberResponse)=>{
          if(response){
            this.memberPierId = response.pierId;
            this.addMember= response.addMember;
            this.existingMember=response.existingMember? 'Yes':'No';
            this.memberObj1.existingMember = response.existingMember;
            this.formNc.referralCase.pierId = response.pierId;
          }
        }, error: (err: HttpErrorResponse) => {
          this.logger.logMsg(err.error);
          const msg = 'We are unable to verify Member details currently, please contact customer support at (877) 697-6703';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },

        });



      }
      this.timerReset =Math.random()* 100;
  }

  openValidateMemberDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Family Member',
        content:
          `<br />
      <h1 class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> Invalid Member</h1>
      <p>This member <span class="text-danger">` +
          this.existingInvalidMemberName +
          `</span> details belongs to different case.</p>
      <p>Please verify the member details. </p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }

  private setPreviousVal(tempSelectedStreetLine: any, propName: string) {
    if(config.validateAddresses){
    switch (propName) {
      case 'resAddress': this.previousValRes = tempSelectedStreetLine; break;
      case 'mailAddress': this.previousValMail = tempSelectedStreetLine; break;
      case 'referralEmployerAddress': this.previousValRefEmp = tempSelectedStreetLine; break;
      case 'referralPolicyAddress': this.previousValRefPol = tempSelectedStreetLine; break;
      default: "";
    }
  }
  }
  validateCarrierNm(event : any, control: NgModel ){
    let regex=/^(?![ \-/()])([a-zA-Z0-9]+(?: {0,1}(?:[\-/] {0,1})?[a-zA-Z0-9]+)*)(?: {0,1}\((?![ -])[A-Za-z]+(?:\s{0,1}[A-Za-z]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z]+)*\) *(?:[a-zA-Z0-9]+(?: {0,1}(?:[\-/] *)?[a-zA-Z0-9]+)*)*)?(?![ \-/()])$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePlanNm(event : any, control: NgModel ){
    let regex=/^(?![ .,\/#&-])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[.,\/#&-]\s{0,1}(?![ .,\/#&-])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validateGroupNum(event : any, control: NgModel ){
    let regex=/^(?![ -])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePolicyId(event : any, control: NgModel ){
    let regex=/^[a-zA-Z0-9]+$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
}
